import axios from "axios";

 
const baseURLVitelWireless = process.env.REACT_APP_BASE_URL;
const baseURLVitelWireless2 = process.env.REACT_APP_BASE_URL_2;
const vitelWirelessAxiosHome = process.env.REACT_APP_BASE_URL_HOME;
 
 



const vitelWirelessAxios = axios.create({
  baseURL: baseURLVitelWireless
});

const vitelWirelessAxios2 = axios.create({
  baseURL: baseURLVitelWireless2
});



 
 
export { vitelWirelessAxios, vitelWirelessAxios2, vitelWirelessAxiosHome };